import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { AuthorizeCard } from '@one-thd/sui-icons';
var InterimReturnStatus = function () {
    return (React.createElement("div", { className: "sui-flex sui-gap-2 sui-items-center" },
        React.createElement(AuthorizeCard, { size: "small" }),
        React.createElement(Typography, { variant: "body-base" }, "Initiated")));
};
export default InterimReturnStatus;
